import TabTitle from '../../components/atoms/tab-title/tab-title';
import { MetaPages } from '../../enums/pages';
import ComingSoon from '../../components/atoms/coming-soon/coming-soon';
import MarginSpacing from '../../components/atoms/margin-spacing/margin-spacing';
import SectionTitle from '../../components/atoms/section-title/section-title';
import { getNewsBannerContent } from '../../services/news';
import Tabs from '../../components/molecules/tabs/tabs';
import HeaderContainer from '../../components/molecules/header-container/header-container';
import { newsRoutes } from '../../config/routes/pages';
import { ContentType } from '../../types/content';

type IndexProps = {
  newsBannerContent: ContentType;
};

export function Index(props: IndexProps) {
  const { newsBannerContent } = props;

  return (
    <>
      <TabTitle page={MetaPages.NEWS_AND_EVENTS} />
      <HeaderContainer {...newsBannerContent} />
      <Tabs tabItems={newsRoutes} />
      <MarginSpacing margin="mb-10 lg:mb-20" />
      <SectionTitle title="PRODUCT UPDATES" />
      <MarginSpacing margin="mb-10 lg:mb-20" />
      <ComingSoon />
      <MarginSpacing margin="mb-20 lg:mb-40" />
    </>
  );
}

export async function getStaticProps() {
  const newsBannerContent = await getNewsBannerContent();

  return {
    props: {
      newsBannerContent
    }
  };
}

export default Index;
